import React, { FC } from 'react';
import { Field } from 'react-final-form';
import { intValuesHelpers } from '@factorin/util';

import { WithT } from 'Modules/core/i18n';
import { InputField, Stack } from 'Modules/ui3';
import { SliderField } from 'Modules/business/forms';

import { FormValues, Role } from '../types';
import { innValidatorsByRole, useRateValueFormatter } from '../utils';


export const IssuerBlock: FC<WithT> = ({ t }) => {
    const rateFormatter = useRateValueFormatter(t);
    return (
        <Stack spacing={6}>
            <Field
                name='inn'
                component={InputField}
                label={t('fields.inn')}
                validate={(value, values: FormValues) =>
                    innValidatorsByRole[values.role](value, values)}
                parse={intValuesHelpers.parse}
                required
            />
            <Field
                name='rate'
                label={t('fields.rate', { context: Role[Role.ISSUER] })}
                component={SliderField}
                min={-5}
                max={5}
                step={0.25}
                valueLabelFormat={rateFormatter}
            />
        </Stack>
    );
};
